<div class="organization-settings-controls">
    <div class="form-row">
        <div class="head-row">
            <h2>{{ 'aumico_reports_main_navigation_design_settings' | i18next }}</h2>
            <ham-button icon="assets/hamIcons/floppy.svg" (click)="save()"
                >{{ 'aumico_reports_design_settings_save_button' | i18next }}</ham-button
            >
        </div>
        <div>
            <h3>{{ 'aumico_reports_design_settings_select_colors_title' | i18next }}</h3>
            <div class="colorsPickers">
                <span class="color-box">
                    <label for="textColor">{{ 'aumico_reports_print_text_color' | i18next }}</label>
                    <input
                        type="color"
                        [formControl]="form.get('styleOptions')['controls']['textColor']"
                        name="textColor"
                    />
                </span>
                <span class="color-box">
                    <label for="backgroundColor">{{ 'aumico_reports_print_highlight_color_1' | i18next }}</label>
                    <input
                        type="color"
                        [formControl]="form.get('styleOptions')['controls']['backgroundColor']"
                        name="backgroundColor"
                    />
                </span>
                <span class="color-box">
                    <label for="backgroundColorPY">{{ 'aumico_reports_print_highlight_color_2' | i18next }}</label>
                    <input
                        type="color"
                        [formControl]="form.get('styleOptions')['controls']['backgroundColorPY']"
                        name="backgroundColorPY"
                    />
                </span>
                <span class="color-box">
                    <label for="titleColor">{{ 'aumico_reports_print_title_color' | i18next }}</label>
                    <input
                        type="color"
                        [formControl]="form.get('styleOptions')['controls']['titleColor']"
                        name="titleColor"
                    />
                </span>
                <span class="color-box">
                    <label for="tableHeaderColor">{{ 'aumico_reports_print_table_header_color' | i18next }}</label>
                    <input
                        type="color"
                        [formControl]="form.get('styleOptions')['controls']['tableHeaderColor']"
                        name="tableHeaderColor"
                    />
                </span>

                <span class="color-box">
                    <label for="tableFooterColor">{{ 'aumico_reports_print_table_footer_color' | i18next }}</label>
                    <input
                        type="color"
                        [formControl]="form.get('styleOptions')['controls']['tableFooterColor']"
                        name="tableFooterColor"
                    />
                </span>
            </div>
        </div>
        <div>
            <h3>{{ 'aumico_reports_design_settings_preview_title' | i18next }}</h3>

            <div class="preview-wrapper previewTable">
                <h2 [style.color]="form.get('styleOptions')['controls']['titleColor'].value">
                    {{ 'aumico_reports_design_settings_example_title' | i18next }}
                </h2>
                <h3 [style.color]="form.get('styleOptions')['controls']['titleColor'].value">
                    {{ 'aumico_reports_design_settings_example_subtitle' | i18next }}
                </h3>
                <div style="width: 100%">
                    <table style="width: 100%">
                        <thead>
                            <tr>
                                <th [style.color]="form.get('styleOptions')['controls']['tableHeaderColor'].value">
                                    {{ 'aumico_reports_design_settings_example_title_row' | i18next }}
                                </th>
                                <th
                                    [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColor'].value"
                                    [style.color]="form.get('styleOptions')['controls']['tableHeaderColor'].value"
                                >
                                    {{ currentYearDate |dateLocale}}
                                </th>
                                <th
                                    [style.color]="form.get('styleOptions')['controls']['tableHeaderColor'].value"
                                    [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColorPY'].value"
                                >
                                    {{ previousYearDate |dateLocale}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td [style.color]="form.get('styleOptions')['controls']['textColor'].value">
                                    {{ 'aumico_reports_design_settings_example_normal_row' | i18next }}
                                </td>
                                <td
                                    [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColor'].value"
                                    [style.color]="form.get('styleOptions')['controls']['textColor'].value"
                                >
                                    {{ 1000 | finNumber }}
                                </td>
                                <td
                                    [style.color]="form.get('styleOptions')['controls']['textColor'].value"
                                    [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColorPY'].value"
                                >
                                    {{ 1000 | finNumber }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td [style.color]="form.get('styleOptions')['controls']['tableFooterColor'].value">
                                    {{ 'aumico_reports_design_settings_example_footer_row' | i18next }}
                                </td>
                                <td
                                    [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColor'].value"
                                    [style.color]="form.get('styleOptions')['controls']['tableFooterColor'].value"
                                >
                                    {{ 1000 | finNumber }}
                                </td>
                                <td
                                    [style.color]="form.get('styleOptions')['controls']['tableFooterColor'].value"
                                    [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColorPY'].value"
                                >
                                    {{ 1000 | finNumber }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
